import { render } from "./transfer.vue?vue&type=template&id=dd0305c0&scoped=true"
import script from "./transfer.vue?vue&type=script&lang=js"
export * from "./transfer.vue?vue&type=script&lang=js"
script.render = render
script.__scopeId = "data-v-dd0305c0"

export default script